

export const PATH = {
    PRODAT_KVARTIRU: "prodat-kvartiru-murmansk",           // 🔍 Продать квартиру в Мурманске
    PRODAT_ROOMS: "prodat-komnatu-murmansk",                        // 🔍 Продать комнату
    PRODAT_DOLI: "prodat-dolyu-v-kvartire-murmansk",                // 🔍 Продать долю в квартире
    LAWYER: "yuridicheskie-uslugi-murmansk",               // 🔍 Юридические услуги Мурманск
    ZEMELNYY_UCHASTOK: "prodat-zemelnyy-uchastok-murmansk",         // 🔍 Продажа земельных участков
    ABOUT: "murmanclick-agentstvo-nedvizhimosti",         // 🔍 Название бренда + ключ (агентство)
    KUPIT_KVARTIRU: "kupit-kvartiru-murmansk",             // 🔍 Купить квартиру в Мурманске
}

